<template>
	<div class="chat">
		<el-row class="margin-bottom-15" >
			<el-card class="box-card liaotian" :body-style="{ padding: '0px' }">
					<detail-nav title="ChatGPT-3.5" @navigateBack="navigateBack"></detail-nav>
					<!-- <div class="head_title">
						ChatGPT-3.5
					</div> -->
					
					<!-- 列表 -->
					<div ref="targetDiv"  class="messageCard" @scroll="handleScroll">
						<div v-if="loading" style="height: 50px;" v-loading="loading"  element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"></div>
						<div v-if="loading_end && list.length > 10" style="height: 50px;text-align: center;font-size: 14px;line-height: 50px;color: #999;">没有更多了</div>
						<div v-for="item in list" >
							<div  v-if="item.from_type == 2">
								<div style="display: flex;align-items: center;margin-bottom: 10px;">
									<img :src="imgpath+'/brand/chatgpt.png'" style="width: 30px;height: 30px;margin-right: 5px;"/>
									<span>ChatGpt</span>
								</div>
								
								<div class="ai_msg">{{item.content}}</div>
							</div>
							
							
							<div class="user_msg"  v-if="item.from_type == 1">
								<div>{{item.content}}</div>
							</div>
						</div>
					</div>
				
				
					<!-- 输入模块 -->
					<div class="send_view">
						
						<div style="display: flex;padding: 15px 0 10px;">
							<div :class="model_type==1?'c_btn select_btn':'c_btn'" @click="model_type=1">通用问答</div>
							<div :class="model_type==2?'n_btn select_btn':'n_btn'"  @click="model_type=2">对比标题生成</div>
						</div>
						
						<el-input
						  type="textarea"
						  placeholder="输入您的需求开始跟GPT交流"
						  v-model="textarea2"
						  class="textareaview"
						  :rows="6"
						  >
						</el-input>
						
						 <el-button class="s_btn" :disabled="btn_disabled" :loading="btn_disabled" type="primary" @click="fasong()">{{btn_disabled?'正在生成':'生成'}}</el-button>
					</div>
					
			</el-card>
		</el-row>

		

	</div>
</template>

<script>
	import {baseURL} from '@/config';
	import axios from 'axios';
	import {getAccessToken} from '@//utils/accessToken'
	import {
		getchatgpt
	} from '@/api/chatgpt';
	
	import detailNav from '@/components/detail-nav.vue';
	
	export default {
		components: {
			detailNav
		},
		data() {
			return {
				imgpath: baseURL + '/public/images',
				list:[],
				textarea2:'',
				btn_disabled:false,
				currentPage:1,//记录页数
				loading:false,//加载动画
				loading_end:false,//是否分页加载完毕
				onload_time:'',//进入页面时间
				model_type:1,//gpt模型选择,
				scrollHeight:0,//记录滚动条位置，更新历史记录后返回加载的位置
			}
		},
		created() {
			this.onload_time = getDate();
		},
		mounted() {
			this.getlist(1);
		},
		methods: {
			getlist(is_one=0){
				if(!is_one){
					this.loading = true;
					//记录一下当前的高度
					let container = this.$refs.targetDiv;
					this.scrollHeight = container.scrollHeight;
				}
				getchatgpt({
					page: this.currentPage,
					onload_time:this.onload_time
				}).then(res => {
					console.log(res);
					if(res.data.length > 0){
						if(is_one){
							this.list = res.data;
							this.$nextTick(() => {
							  this.roll_end_list();
							});
						}else{
							var newArray = [...res.data, ...this.list];
							this.list = newArray;
							this.loading = false;
							//回到加载前位置
							this.$nextTick(() => {
							   let container = this.$refs.targetDiv;
							   container.scrollTop = (container.scrollHeight - this.scrollHeight) - 115;
							});
						}
					}else{
						//到底了
						this.loading = false;
						this.loading_end = true;
					}
				})
			},
			// 发送
		    fasong(){
				var that = this;
				var send_text = this.textarea2.trim();
				if(send_text == ''){
					this.$message.error('发送内容不可为空');
					return false;
				}
				
				this.textarea2 = '';
				this.list.push({'from_type':1,'content':send_text});
				this.btn_disabled = true;
				this.list.push({'from_type':2,'content':'...'});
				this.$nextTick(() => {
				  that.roll_end_list();
				});
			
			    // 发送sse请求，逐字输出
				axios({
				  url: baseURL + '/Api/brand.ChatGpt/getGptReply',
				  method: 'POST',
				  headers: {
				    'Accept': 'text/html',
				    'Authorization': getAccessToken()
				  },
				  data: { 'text_content':send_text,'model_type':that.model_type},
				  onDownloadProgress(progressEvent) {
				    // 处理进度信息
				    // console.log('进度信息：', progressEvent);
				
				    // 获取分块数据
				    const res_content = progressEvent.currentTarget.response;
					console.log(res_content);
				
					let lastIndex = that.list.length - 1;
				    if (res_content.indexOf('[DONE]') != -1) {
				      let new_content = res_content.replace('[DONE]', '');
				      that.list[lastIndex].content = new_content;
				    }  else {
				      that.list[lastIndex].content = res_content;
					  
					  that.roll_end_list();
				    }
				  }
				}).then(response => {
				    // 处理响应数据
				    console.log(response.data);
					that.btn_disabled = false;
				}).catch(error => {
				    // 处理错误
				    console.error(error);
				});
			},
			// 监听触顶事件
			handleScroll(event){
				var that = this;
				if (event.target.scrollTop === 0) {
				        // 滚动条到顶事件处理逻辑
				        console.log('滚动条到顶');
						if(!this.loading_end){
							that.currentPage+=1;
							that.getlist();
						}
				}
			},
			// 滚动list底部
			roll_end_list(){
				const targetDiv = this.$refs.targetDiv;
				targetDiv.scrollTop = targetDiv.scrollHeight;
			},
			navigateBack() {
				this.$router.go(-1)
			}
		}
	}
	
	function getDate(){
		var currentDate = new Date();
		
		var currentYear = currentDate.getFullYear();
		var currentMonth = ('0' + (currentDate.getMonth() + 1)).slice(-2); // 使用slice()方法获取后两位
		var currentDay = ('0' + currentDate.getDate()).slice(-2); // 使用slice()方法获取后两位
		var currentHour = ('0' + currentDate.getHours()).slice(-2); // 使用slice()方法获取后两位
		var currentMinute = ('0' + currentDate.getMinutes()).slice(-2); // 使用slice()方法获取后两位
		var currentSecond = ('0' + currentDate.getSeconds()).slice(-2); // 使用slice()方法获取后两位
		return currentYear + '-' + currentMonth + '-' + currentDay+' '+currentHour + ':' + currentMinute + ':' + currentSecond;
	}

</script>

<style scoped="scoped">
	.liaotian{
		/* height: calc(100vh - 120px); */
		height: auto;
	}
	.head_title{
		height: 63px;
		line-height: 63px;
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #333333;
		padding-left: 20px;
		box-sizing: border-box;
		border-bottom: 1px solid #EEEEEE;
	}
	.send_view{
		padding-left: 20px;
		padding-right: 20px;
		box-sizing: border-box;
	}
	.messageCard {
		height: 400px;
		padding: 0 20px;
		border-bottom: 1px solid #EEEEEE;;
		overflow-y: scroll;
	}
	.messageCard::-webkit-scrollbar {
	    width: 4px;
	}
	.messageCard::-webkit-scrollbar-thumb {
	    border-radius: 10px;
	    background: rgba(0,0,0,0.2);
	}
	.messageCard::-webkit-scrollbar-track {
	    border-radius: 0;
	    background: none;
	}
	.c_btn{
		width: 96px;
		height: 40px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #666666;
		text-align: center;
		line-height: 40px;
		margin-right: 20px;
		cursor: pointer;
	}
	.n_btn{
		width: 124px;
		height: 40px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #666666;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
	}
	.select_btn{
		font-weight: 400;
		background: #E6F1FC;
		border: 1px solid #A3D0FD;
		color: #1989FA;
	}
	.s_btn{
		width: 110px;
		height: 40px;
		background: #0486FE;
		border-radius: 4px;
		margin: 16px 0;
	}
	.user_msg{
		display:flex;
		justify-content:flex-end;
		margin-bottom: 15px;
	}
	.user_msg div{
		max-width: 80%;
		line-height: 20px;
		padding: 20px;
		white-space: pre-line;
		background: #0486FE;
		border-radius: 16px 0px 16px 16px;
		opacity: 0.7;
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}
	.ai_msg{
		max-width: 80%;
		display: inline-block;
		white-space: pre-line;
		padding: 20px;
		background: #F5F5F5;
		border-radius: 0px 16px 16px 16px;
		line-height: 20px;
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #333333;
		margin-bottom: 15px;
	}
	
</style>
